<i18n>
{
    "uk": {
        "title": "Програма курсу"
    },
    "en": {
        "title": "Course program"
    }
}
</i18n>

<template>
    <div
        :id="block.id || `${block.type}-${uid}`"
        class="mt-6 mt-md-8 mt-lg-10"
    >
        <div class="page-container">
            <h2 class="ta-center h4 h3-sm h2-md fw-800 fw-sm-700">
                {{ $t('title', locale) }}
            </h2>

            <div class="p-relative">
                <button
                    v-if="edit"
                    class="btn-bg btn-lg rounded icon-ic-pencil-outline elevate edit-btn"
                    @click="$emit('openProgramEditor')"
                />

                <p class="ta-center f-sm-semilarge f-lg-large mt-2 mb-3 description mx-auto" v-if="block.programDescription">
                    {{ block.programDescription }}
                </p>
            </div>

            <Card class="p-2 p-md-3">
                <ProgramModule
                    v-for="module in modulesToshow"
                    :key="module.id"
                    :module="module"
                    :edit="edit"
                    @openModuleEditor="openModuleEditor"
                />

                <TransitionExpand>
                    <div v-if="expanded">
                        <ProgramModule
                            v-for="module in modulesToHide"
                            :key="module.id"
                            :module="module"
                            :edit="edit"
                            @openModuleEditor="openModuleEditor"
                        />
                    </div>
                </TransitionExpand>
            </Card>

            <TransitionExpand>
                <div v-if="!this.expanded && modulesToHide.length">
                    <button
                        @click="expanded = true"
                        class="btn-ghost mt-3 load-page d-flex align-items-center"
                    >
                        <span class="color-gray-3 icon-ic-union icon" /> {{$t('general.loadMore')}}
                    </button>
                </div>
            </TransitionExpand>
        </div>
    </div>
</template>

<script>
import { useCourseLandingStore } from '~/stores/courseLanding';

let uid = 0;

export default {
    components: {
        ProgramModule: () => import('~/components/creative-practice/course-landing/ProgramModule.vue'),
        Card: () => import('~/components/cards/Card.vue'),
        TransitionExpand: () => import('~/components/collapse/TransitionExpand.vue')
    },

    props: {
        block: Object,
        edit:  Boolean,
    },

    data () {
        uid++;

        return {
            uid,
            expanded: false
        };
    },

    computed: {
        locale () {
            return this.courseLandingStore.locale;
        },

        course () {
            return this.courseLandingStore.course;
        },

        courseLandingStore () {
            return useCourseLandingStore();
        },


        program () {
            let program = this.$structuredClone(this.course?.program || []);

            let filteredModules = [];

            for (let module of program) {
                if (['practice', 'theory'].includes(module.module.type)) {
                    filteredModules.push(module.module);
                }
            }

            filteredModules.sort((a, b) => a.order - b.order);

            return filteredModules;
        },

        maxLength () {
            return this.program.length == 11 ? 11 : 10;
        },

        modulesToshow () {
            return this.program.slice(0, this.maxLength);
        },

        modulesToHide () {
            return this.program.slice(this.maxLength);
        }
    },

    methods: {
        openModuleEditor (id) {
            this.$emit('openModuleEditor', id);
        }
    }
}
</script>

<style lang="postcss" scoped>
    .description {
        max-width: 838px;
    }

    .p-relative {
        position: relative;
    }

    .edit-btn {
        position: absolute;
        top: -48px;
        right: -8px;
        z-index: 10;
    }

    .load-page {
        padding: 18px;
        text-transform: uppercase;
        margin: 0 auto;

        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        border-radius: 8px;

        .icon{
            font-size: 20px;
            margin-right: 8px;
        }
    }
</style>